export const COLORS = {
  'KMRS-Darkmode': '#282D33',
  'KMRSx24-Orange': '#EC4E20',
  'KMRSx24-GreyLight': '#AAABBC',
  'KMRSx24-GreyDark': '#373F47',
  'KMRS-Light': '#AAABBC',
  'KMRS-Dark': '#373F47'
}
